export default (amount, currency = null) => {
  const options = { minimumFractionDigits: 2 };
  const formattedAmount = parseFloat(amount).toLocaleString('pl-PL', options);
  return formattedAmount + (currency ? ` ${currency}` : '');
}
